<template>
  <BaseConfirmModal v-bind="confirmModal" v-on:confirm="onConfirm">
    <template v-slot:header>
      <h3>Exclusão de atividade</h3>
    </template>

    <template v-slot:default>
      <p>
        Confirma a exclusão da atividade "{{ atividade }}"? Certifique-se de que
        essa atividade fora desassociada de todos os perfis.
      </p>
    </template>
  </BaseConfirmModal>
</template>

<script>
export default {
  name: "AtividadeDeletionConfirmModal",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    value: Object
  },
  data() {
    return {
      confirmModal: {
        id: this.id
      }
    };
  },
  computed: {
    atividade() {
      return this.value ? this.value.nome : "";
    }
  },
  methods: {
    onConfirm(event) {
      this.$emit("confirm", event);
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 2.28rem;
  margin: 1.52rem 0 0.912rem 0;
}
</style>
